import React, { Component } from 'react';
import { connect } from 'react-redux';
import './progressModal.css';
import T from 'i18n-react';
import FontAwesome from 'react-fontawesome';
import BaseModal from '../Modal/BaseModal';
import SigningActions from '../../reducers/signingRedux';

class ProgressModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
            spouseName: this.props.spouseName || '',
            titleKey: this.props.titleKey,
            subTitleKey: this.props.subTitleKey,
            primaryName: this.props.primaryName || '',
            envelopeId: this.props.envelopeId,
            recipientId: this.props.recipientId,
            processingStartTime: null
        }
        this.timeoutId = null;
    }

    componentDidMount() {
        // Safety timeout: if modal is still visible after 30 seconds, allow closing
        this.timeoutId = setTimeout(() => {
            if (this.state.visible) {
                console.warn('[ProgressModal] Modal timeout reached - enabling manual close');
            }
        }, 30000);
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.visible !== this.state.visible) {
            this.setState({ visible: newProps.visible })
            if (newProps.visible && !this.state.visible) {
                // Modal opening - reset timeout
                if (this.timeoutId) clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(() => {
                    if (this.state.visible) {
                        console.warn('[ProgressModal] Modal timeout reached - enabling manual close');
                    }
                }, 30000);
            }
        }

        if (newProps.spouseName !== this.state.spouseName) {
            this.setState({ spouseName: newProps.spouseName || ''})
        }

        if (newProps.primaryName !== this.state.primaryName) {
            this.setState({ primaryName: newProps.primaryName || ''})
        }


        if (newProps.titleKey !== this.state.titleKey) {
            this.setState({ titleKey: newProps.titleKey })
        }

        if (newProps.subTitleKey !== this.state.subTitleKey) {
            this.setState({ subTitleKey: newProps.subTitleKey })
        }

        if (newProps.envelopeId !== this.state.envelopeId) {
            this.setState({ envelopeId: newProps.envelopeId })
        }

        if (newProps.recipientId !== this.state.recipientId) {
            this.setState({ recipientId: newProps.recipientId })
        }
    }

    handleClose = () => {
        const { signingState } = this.props;
        
        // Allow cancellation if:
        // 1. In 'in_progress' state (before redirect to Adobe)
        // 2. In 'processing' state BUT callback is stuck (failsafe)
        if (signingState === 'in_progress' || signingState === 'processing') {
            this.setState({ visible: false });
            
            // Reset signing state
            if (this.props.completeFormSigning) {
                this.props.completeFormSigning('cancelled');
            }
            if (this.props.signingStateReset) {
                this.props.signingStateReset();
            }
        }
    }

    render() {
        var params = {
            ...this.props.params,
            SpouseName: this.state.spouseName,
            PrimaryName: this.state.primaryName
        }

        return (
            <div style={{ width: '0px', height: '0px' }}>
                <BaseModal show={this.state.visible} onClose={this.handleClose} layoutType={this.props.layoutType} >
                    <div className="progressRootContainer">
                        <div className="progressSpinnerContainer">
                            <FontAwesome className='fa-spinner' name='spinner' pulse size='3x' style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0)', color: '#14AA40', align: 'center' }} />
                        </div>
                        <h2>{T.translate(this.state.titleKey, params)}</h2>
                        <span className="progressRootContainerSpan">{T.translate(this.state.subTitleKey, params)}</span>
                    </div>
                </BaseModal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    envelopeId: state.signing.envelopeId,
    recipientId: state.signing.recipientId,
    signingState: state.signing.signingState
})

const mapDispatchToProps = (dispatch) => ({
    completeFormSigning: (signingState) => dispatch(SigningActions.completeFormSigning(signingState)),
    processDocumentCallback: (status) => dispatch(SigningActions.processDocumentCallback(status)),
    signingStateReset: () => dispatch(SigningActions.signingStateReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(ProgressModal)